import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ButtonToolbar, Button, Icon } from 'rsuite';
import { get, isEmpty, keys, map } from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import { MemberType } from '../../../interfaces/guest';
import { modifyAccess } from '../../../helpers/permission';
import toCustomFieldValue from '../../../helpers/toCustomFieldValue';
import { MODULE as GUEST_MODULE } from '../../../constants/permissions/guest';
import { DetailsItem, ItemLabel, ItemValue } from '../ViewElements';
import { fetchHouseholdMemberColumns } from '../../../redux/sagas/routines';
import { getActiveColumnsByName } from '../../../redux/selectors/household-member-column';
import AccessControl from '../../AccessControl';

const HouseholdMemberView = ({
  data,
  onEdit,
  onDelete,
  allowEdit,
  allowDelete
}) => {
  const dispatch = useDispatch();
  const columnSettings = useSelector(getActiveColumnsByName);
  const columns = keys(columnSettings);

  useEffect(
    () => {
      if (isEmpty(columnSettings)) dispatch(fetchHouseholdMemberColumns());
    },
    [columnSettings]
  );

  return (
    <div style={{ marginBottom: 10 }}>
      {(allowEdit || allowDelete) && (
        <ButtonToolbar style={{ float: 'right' }}>
          {allowDelete && (
            <AccessControl allowOnlyFor={modifyAccess(GUEST_MODULE)}>
              <Button onClick={onDelete}>
                <Icon icon="trash" /> Remove
              </Button>
            </AccessControl>
          )}
          {allowEdit && (
            <AccessControl allowOnlyFor={modifyAccess(GUEST_MODULE)}>
              <Button appearance="primary" onClick={onEdit}>
                <Icon icon="pencil" /> Edit
              </Button>
            </AccessControl>
          )}
        </ButtonToolbar>
      )}
      {map(
        field => (
          <DetailsItem key={`field-${field}`}>
            <ItemLabel>{get(`${field}.label`, columnSettings)}</ItemLabel>
            <ItemValue>
              {toCustomFieldValue(data[field], columnSettings[field])}
              {field === 'age' &&
                ` ( age: ${moment().diff(data.age, 'years')} )`}
            </ItemValue>
          </DetailsItem>
        ),
        columns
      )}
    </div>
  );
};

HouseholdMemberView.propTypes = {
  data: MemberType.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool,
  allowDelete: PropTypes.bool
};

HouseholdMemberView.defaultProps = {
  allowEdit: true,
  allowDelete: true
};

export default HouseholdMemberView;
